import { render, staticRenderFns } from "./TierBadge.vue?vue&type=template&id=c9a7d792&scoped=true"
import script from "./TierBadge.vue?vue&type=script&lang=js"
export * from "./TierBadge.vue?vue&type=script&lang=js"
import style0 from "./TierBadge.vue?vue&type=style&index=0&id=c9a7d792&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9a7d792",
  null
  
)

export default component.exports